import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import SideModal from "../../../../common/modal/SideModal.component";
import Table from "../../../../common/table/Table.component";
import CreateProcedureOutcome from "../../../components/procedure-outcomes-component/CreateProcedureOutcome.component";
import ProcedureOutcomeClient from "../../../api-services/coders/procedure-outcome/procedure-client";
import HandlingResponse from "../../../../common/handling-response/handlingResponse";
import ButtonWithComfirmation from "../../../../common/button-with-confirmation/ButtonWithConfirmation.component";

const ProcedureOutcome = () => {
  const tableName = 'SP_PROCEDURE_OUTCOME';
  
  const columns = [
    {
      Header: "Назив",
      accessor: "name",
      disableFilters: false,
    },
    {
      Header: "Тежина",
      accessor: "weight",
    },
    {
      Header: "Активан",
      accessor: "isActive",
      Cell: ({ row }) => {
          return row.original.isActive && <FontAwesomeIcon icon={solid("check")} />;
      },
    },
    {
      accessor: "edit",
      disableSortBy: true,
      className: "two-buttons-column",
      Cell: ({ row }) => {
        return (
          <>
            <button
              className="btn btn-primary table-btn"
              onClick={() => onEditClick(row.original)}
              type="button"
            >
              <FontAwesomeIcon icon={solid("pencil")} />
            </button>
            <ButtonWithComfirmation
            className="btn btn-danger table-btn" 
            onClick={() => onDeleteClick(row.original.id)}
            contentText={"Исход поступка ће бити трајно обрисан."}
            handleYesText={"Обриши"}
            >
              <FontAwesomeIcon icon={solid("times")} />
            </ButtonWithComfirmation>
          </>
        );
      },
    },
  ];

  const [procedureOutcome, setProcedureOutcome] = useState([]);
  const [isCreate, setIsCreate] = useState(true);
  const [show, setShow] = useState(false);
  const [rowData, setRowData] = useState({
    id: 0,
    name: "",
    weight: "",
    isActive: true
  });
  const client = new ProcedureOutcomeClient();
  
  useEffect(() => {
    ProcedureOutcome();
  }, []);

  const showModal = () => setShow(true);
  const hideModal = () => {
    setShow(false);
    setRowData({
      id: 0,
      name: "",
      weight: "",
      isActive: true
    });
  }
  
  const onCreateClick = () => {
    setIsCreate(true);
    setRowData({
      id: 0,
      name: "",
      weight: "",
      isActive: true
    });
    showModal();
  };

  const onEditClick = (row) => {
    setIsCreate(false);
    setRowData(row);
    showModal();
  };
  const onDeleteClick = async (id) => {
    var response = await client.DeleteProcedureOutcome(id);
    var handledResponse = HandlingResponse(response);
    if(handledResponse !== 'Error') {
      let procedureOutcomeCopy = procedureOutcome.filter((x) => x.id !== id);
      setProcedureOutcome(procedureOutcomeCopy);
    }
  };

  const ProcedureOutcome = async () => {
    await client.ProcedureOutcome().then((response) => {
      var handledResponse = HandlingResponse(response);
      handledResponse !== 'Error' && setProcedureOutcome(handledResponse);
    });
  }

  return (
    <>
      <h4>Исходи поступака</h4>
      <div className="text-right">
        <button
          onClick={onCreateClick}
          type="button"
          className="btn btn-primary"
        >
          Додај нови исход поступка
        </button>
      </div>
      <Table
        columns={columns}
        data={procedureOutcome}
        tableName={tableName}
        rememberFilter={true}
        serverSide={false}
      />
      <SideModal
        show={show}
        handleClose={hideModal}
        title={
          isCreate ? "Креирање новог исхода поступка" : "Измена исхода поступка"
        }
      >
        <CreateProcedureOutcome
          row={rowData}
          isCreate={isCreate}
          handleCallback={() => {
            hideModal();
            ProcedureOutcome();
          }}
        />
      </SideModal>
    </>
  );
};

export default ProcedureOutcome;
